// 25 seconds
const MIN_SLOWED_THROTTLE_SPEED = 1000 * 25;
// 30 seconds
const MAX_SLOWED_THROTTLE_SPEED = 1000 * 30;
// Stagger throttles so that we don't get all the data slamming in at once, between 5 and 30 seconds
export const getIdleTableThrottle = () => Math.floor(Math.random() * (MAX_SLOWED_THROTTLE_SPEED - MIN_SLOWED_THROTTLE_SPEED) + MIN_SLOWED_THROTTLE_SPEED);
